import React, { useState, useEffect } from 'react';
import { TailSpin } from "react-loader-spinner";

export  const DownloadNotification = ({ notification, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (notification.show) {
      setIsVisible(true);
      
      // Auto-hide for success and error notifications
      if (notification.type !== 'preparing') {
        const timer = setTimeout(() => {
          setIsVisible(false);
          setTimeout(() => onClose(), 300); // Wait for animation to complete
        }, 3000);
        
        return () => clearTimeout(timer);
      }
    } else {
      setIsVisible(false);
      setTimeout(() => onClose(), 300);
    }
  }, [notification, onClose]);

  const getIcon = () => {
    switch (notification.type) {
      case 'preparing':
        return (
          <div className="spinner-border spinner-border-sm text-primary d-flex justify-content-center" role="status">
            <div className="visually-hidden" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative'}}>
            <TailSpin
                    visible={true}
                    height="20"
                    width="20"
                    color="#03A84E"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{}}
                    wrapperClass=""
                  /> 
                   &nbsp;  &nbsp;
            </div>
          </div>
        );
      case 'success':
        return (
          <div className="text-success d-flex justify-content-center">
            <svg width="20" height="20" fill="currentColor" className="bi bi-check-circle-fill" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.061L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
            </svg>
            &nbsp;  &nbsp;
          </div>
        );
      case 'error':
        return (
          <div className="text-danger d-flex justify-content-center">
            <svg width="20" height="20" fill="currentColor" className="bi bi-x-circle-fill" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
            </svg>
            &nbsp;  &nbsp;
          </div>
        );
      default:
        return null;
    }
  };

  const getAlertClass = () => {
    switch (notification.type) {
      case 'preparing':
        return 'alert-info';
      case 'success':
        return 'alert-success';
      case 'error':
        return 'alert-danger';
      default:
        return 'alert-secondary';
    }
  };

  if (!notification.show) return null;

  return (
    <>
      
      <div
        className={`notification-container ${
          isVisible ? 'notification-slide-in' : 'notification-slide-out'
        }`}
      >
        <div className={`alert ${getAlertClass()} notification-card`} role="alert">
          <div className="d-flex align-items-start justify-content-center">
            <div className="me-3 mt-1 pe-3">
              {getIcon()}
            </div>
            <div className="notification-content ms-4 flex-grow-1">
              <h6 className="alert-heading mb-1 fw-semibold">
                {notification.title}
              </h6>
              <p className="mb-0 small">
                {notification.message}
              </p>
            </div>
          </div>
          
          {notification.type !== 'preparing' && (
            <button
              type="button"
              className="notification-close"
              onClick={() => {
                setIsVisible(false);
                setTimeout(() => onClose(), 300);
              }}
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          )}
        </div>
      </div>
    </>
  );
};

// Hook for managing notifications
export const useNotification = () => {
  const [notification, setNotification] = useState({
    show: false,
    type: '',
    title: '',
    message: ''
  });

  const showNotification = (type, title, message) => {
    setNotification({
      show: true,
      type,
      title,
      message
    });
  };

  const hideNotification = () => {
    setNotification(prev => ({ ...prev, show: false }));
  };

  return {
    notification,
    showNotification,
    hideNotification
  };
};

